export const PHARMACIES_LOADING = "PHARMACIES_LOADING";
export const GET_PHARMACIES_SUCCESS = "GET_PHARMACIES_SUCCESS";
export const GET_PHARMACIES_FAILURE = "GET_PHARMACIES_FAILURE";
export const SET_PHARMACY_PAGE = "SET_PHARMACY_PAGE";
export const SET_PROVINCE_PHARMACY_ID = "SET_PROVINCE_PHARMACY_ID";
export const SET_AREA_PHARMACY_ID = "SET_AREA_PHARMACY_ID";
export const SET_LOCATIONS_PHARMACY_ID = "SET_LOCATIONS_PHARMACY_ID";
export const RESET_PHARMACIES = "RESET_PHARMACIES";
// COMMENT: ADD LINE
export const SET_PHARMACIES_NAME = "SET_PHARMACIES_NAME";